export default "__VITE_ASSET__ZCQOFpHp__"